import { TaxTable } from '@reliance/types/models/Tax';
import { formatTaxTableRate } from './TaxTableRate';

export function formatTaxTableDescription(taxTable: TaxTable) {
  if (taxTable == null) {
    return '';
  }

  return `${taxTable.entityName} (${formatTaxTableRate(taxTable)})`;
}
